import { Widget } from '../widget/widget.js';

declare global {
    interface Window {
        recaptchaSuccess: (token: string) => void;
        recaptchaError: () => void;
        recaptchaToken: string;
    }
}

export class ReCaptcha2Widget extends Widget {
    public siteKey: string;
    public token: string;
    public hasError = false;

    constructor($node: HTMLElement, args: Record<string, unknown>) {
        super($node, args);

        this.siteKey = (this.$node.querySelector('.g-recaptcha') as HTMLElement).dataset.sitekey;

        window.recaptchaSuccess = this.recaptchaSuccess.bind(this);
        window.recaptchaError = this.recaptchaError.bind(this);

        this.addRecaptchaApi(`sitekey=${this.siteKey}`).then(() => {}).catch(() => {
            window.recaptchaToken = '';
        });
    }

    /**
     * set token when recaptcha successful
     */
    recaptchaSuccess(token: string): void {
        window.recaptchaToken = token;
        this.token = token;
    }

    recaptchaError(): void {
        this.hasError = true;
    }

    /**
     * loads the recaptcha api script
     */
    addRecaptchaApi(parameters: string): Promise<unknown> {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            document.body.appendChild(script);
            script.onload = resolve;
            script.onerror = reject;
            script.async = true;
            script.defer = true;
            script.src = `https://www.google.com/recaptcha/api.js?${parameters}`;
        });
    }

    /**
     * reset recaptcha if some form validation failed
     */
    async refresh(): Promise<void> {
        window.grecaptcha.reset();
    }

    async validate(): Promise<boolean> {
        return new Promise(resolve => {
            const interval = setInterval((that = this) => {
                const back = (val: boolean) => {
                    clearInterval(interval);
                    resolve(val);
                }
                if (that.hasError === true) back(false);
                if (typeof that.token !== 'undefined' && that.token !== '') back(true);
            }, 50);
        });
    }

    async getValue(): Promise<any> {
        return new Promise(resolve => {
            const intervalId = setInterval(() => {
                if (this.hasError === true) {
                    clearInterval(intervalId);
                    resolve(null);
                }
                if (typeof this.token !== 'undefined' && this.token !== '') {
                    clearInterval(intervalId);
                    resolve(this.token);
                }
            }, 50);
        });
    }

    getStorageName(): string {
        return 'recaptcha';
    }
}
